import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import ListGroup from 'react-bootstrap/ListGroup';


export function Layout() {

    const navigate = useNavigate();

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  

    return (
        <>
            <Navbar bg="light" expand="lg">
                <Container fluid>
                    <Button variant="navbar-toggler" onClick={handleShow}>
                        <span className="navbar-toggler-icon"></span>
                    </Button>
                </Container>
            </Navbar>
            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                <Offcanvas.Title>Menü</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                <ListGroup>
                    <ListGroup.Item action onClick={() => navigate('/agenda')}><i className="bi-bank"></i> Agenda</ListGroup.Item>
                    <ListGroup.Item action onClick={() => navigate('/calendar')}><i className="bi-bank"></i> Kalender</ListGroup.Item>
                    <ListGroup.Item action onClick={() => navigate('/rooms')}><i className="bi-bank"></i> Räume</ListGroup.Item>
                </ListGroup>
                </Offcanvas.Body>
            </Offcanvas>
            <Container fluid>
                <Outlet />
            </Container>            
        </>
    );
}



